<template>
  <div>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-5">
                    <h4 class="card-title mb-0">
                      Aduit Weight Management
                    </h4>
                </div><!--col-->

                <div class="col-sm-7">
                  <div class="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                    <router-link :to="{ path: '/delivery/order/upload-audit-weight' }" class="btn btn-primary ml-1" data-toggle="tooltip" title="Upload Aduit Weight">
                      <i class="fa fa-upload"></i>
                    </router-link>
                  </div><!--btn-toolbar-->
                </div><!--col-->
            </div><!--row-->
            <hr />
            <div class="row mt-4">
              <div class="col-sm-6">
                <h5 class="mb-3">{{ $t('delivery.label.filter_option') }}</h5>
                <b-form v-if="show">
                  <div class="form-group row">
                    <label for="" class="col-sm-3 col-form-label">{{ $t('delivery.label.created_date') }}</label>
                    <div class="col-sm-9 row">
                      <div class="col-sm-6 form-row">
                        <datepicker v-model="filter.createdDateFrom" placeholder="YYYY-MM-DD" :format="customFormatter" input-class="form-control"></datepicker>
                      </div>
                      <div class="col-sm-6 form-row">
                        <datepicker v-model="filter.createdDateTo" placeholder="YYYY-MM-DD" :format="customFormatter" input-class="form-control"></datepicker>
                      </div>
                    </div>
                  </div>
                  <b-form-fieldset
                    :label="$t('delivery.label.reference_no')"
                    :description="$t('delivery.label.please_enter_reference_no')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input type="text" v-model="filter.referenceNo" :placeholder="$t('delivery.label.enter_reference_no')"></b-form-input>
                  </b-form-fieldset>
                  <b-form-fieldset
                    :label="$t('delivery.label.tracking_no')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input type="text" v-model="filter.trackingNo" :placeholder="$t('delivery.label.enter_tracking_no')"></b-form-input>
                  </b-form-fieldset>
                  <!-- <b-form-fieldset
                    :label="$t('delivery.label.courier_name')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-select v-model="filter.courierId" :options="courierOptions" />
                  </b-form-fieldset> -->
                  <b-form-fieldset
                    :label="$t('delivery.label.status')"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-select v-model="filter.status" :options="statusOptions" class="mb-3" />
                  </b-form-fieldset>
                  <b-button type="button" size="sm" variant="primary" @click="onSearchForm"><i class="fa fa-search"></i> {{ $t('delivery.label.search') }}</b-button>
                  <b-button type="reset" size="sm" variant="danger ml-1" @click="onReset"><i class="fa fa-ban"></i> {{ $t('delivery.label.reset') }}</b-button>
                </b-form>
              </div><!--col-->
            </div>
            <div class="row mt-4">
                <div class="col">
                    <div class="table-responsive">
                        <table class="table">
                          <colgroup>
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="7%">
                            <col width="10%">
                          </colgroup>
                          <thead>
                            <tr>
                              <th>{{ $t('delivery.label.batch_id') }}</th>
                              <th>{{ $t('delivery.label.courier_name') }}</th>
                              <th>{{ $t('delivery.label.reference_no') }}</th>
                              <th>{{ $t('delivery.label.tracking_no') }}</th>
                              <th>{{ $t('delivery.label.weight') }}</th>
                              <th>{{ $t('delivery.label.weight_unit') }}</th>
                              <th>{{ $t('delivery.label.status') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(auditWeight, index) in auditWeights" :key="index">
                              <td>{{ auditWeight.batch_request_id }}</td>
                              <td>{{ auditWeight.courier_name }}</td>
                              <td>{{ auditWeight.reference_no }}</td>
                              <td>{{ auditWeight.tracking_no }}</td>
                              <td>{{ auditWeight.weight }}</td>
                              <td>{{ auditWeight.weight_unit }}</td>
                              <td v-html="auditWeight.status_label"></td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="row">
                          <div class="col-sm-12 col-md-5">
                            <div class="mt-2" aria-live="polite">{{ $t('general.list.display') }} {{ this.meta.from }} {{ $t('general.list.to') }} {{ this.meta.to }} {{ $t('general.list.of') }} {{ this.meta.total }} {{ $t('general.list.records') }}</div>
                          </div>
                          <div class="col-sm-12 col-md-7">
                            <nav>
                              <b-pagination align="end" :total-rows="this.meta.total" :per-page="this.meta.per_page" v-model="currentPage" :prev-text="$t('general.list.prev')" :next-text="$t('general.list.next')" @change='changePage' hide-goto-end-buttons/>
                            </nav>
                          </div>
                        </div>
                    </div>
                </div><!--col-->
            </div><!--row-->
        </div><!--card-body-->
    </div><!--card-->

  </div>
</template>

<script>
import datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'auditWeights',
  components: {
    datepicker
  },
  mounted () {
    this.axios.get('/delivery/audit-weight').then(response => {
      this.auditWeights = response.data
      this.meta = response.meta
    }).catch(error => {
      console.log(error)
    })
  },
  computed: {
  },
  data () {
    return {
      modalShow: false,
      displayEditStatus: [2, 4],
      auditWeights: [],
      meta: [],
      filter: {
        createdDateFrom: '',
        createdDateTo: '',
        referenceNo: '',
        trackingNo: '',
        courierId: null,
        status: null
      },
      statusOptions: [
        { value: null, text: this.$t('general.input.please_select_status') },
        { value: 'request', text: 'Request' },
        { value: 'completed', text: 'Completed' }
      ],
      courierOptions: [
      ],
      currentPage: 1,
      show: true
    }
  },
  methods: {
    onReset () {
      // evt.preventDefault()
      this.filter.referenceNo = ''
      this.filter.trackingNo = ''
      this.filter.courierId = ''
      this.filter.createdDateFrom = moment().format('YYYY-MM-DD')
      this.filter.createdDateTo = moment().add(1, 'day').format('YYYY-MM-DD')
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    onSearchForm () {
      this.axios.get('/delivery/audit-weight', {
        params: {
          reference_no: this.filter.referenceNo,
          tracking_no: this.filter.trackingNo,
          courierId: this.filter.courierId,
          date_from: this.filter.createdDateFrom,
          date_to: this.filter.createdDateTo,
          status: this.filter.status
        }
      }).then(response => {
        this.auditWeights = response.data
        this.meta = response.meta
        var vm = this
        response.data.forEach(function (deliveryOrder) {
          vm.referenceNos.push(deliveryOrder.id)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    changePage (pageNum) {
      this.axios.get('/delivery/audit-weight', {
        params: {
          reference_no: this.filter.referenceNo,
          tracking_no: this.filter.trackingNo,
          courier_id: this.filter.courierId,
          date_from: this.filter.createdDateFrom,
          date_to: this.filter.createdDateTo,
          page: pageNum
        }
      }).then(response => {
        this.auditWeights = response.data
        this.meta = response.meta
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
